const swiper = new Swiper('.swiper', {
  autoplay: true,
  loop: true,
  slidesPerView: 2,
  breakpoints: {
    640: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 6,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
